<template>
  <section class="mission-statement">
    <h2>About this site</h2>
    <p>Since falling in love with Critical Role I've loved what others have created in Art, Cosplay, and much more. I always found that I had a hard time to easily search for Critical Role related items to purchase.</p>
    <p>One goal of this website is to help those who want to purchase Critical Role commissions, dice, dice bags, coffee, and much more.</p>
    <p>The other goal of this site is that I really wanted to signal boost all of these wondeful creators!</p>
  </section>
</template>

<script>
export default {
  name: 'MissionStatement'
}
</script>


// WEBPACK FOOTER //
// MissionStatement.vue?9411d724